module.exports = __webpack_public_path__ + "static/media/jake-peterson-NZUYV-NezV0-unsplash.31fae214.jpg";